// extracted by mini-css-extract-plugin
module.exports = {"faqsContainer":"faqsContainer_LX1cc","faq":"faq_3D1kp","answer":"answer_C4md4","question":"question_Hjg_j"};